import { CanceledError } from 'axios';
import { noop, toLower } from 'lodash-es';
const abortControllersMap = new Map();
let abortControllerManageConfig = {
    responseErrorIsEnterCatch: false,
};
/**
 * Updates the abort controller manage configuration.
 *
 * @param {Partial<AbortControllerManageConfig>} _config - The partial configuration to update.
 * @return {void}
 */
function setAbortControllerManageConfig(_config) {
    abortControllerManageConfig = Object.assign(abortControllerManageConfig, _config);
}
/**
 * Generates a unique key for an abort function based on the provided URL and method.
 *
 * @param {string} url - The URL to use when generating the key.
 * @param {Method} [method] - The method to use when generating the key (optional).
 * @return {string} The generated key.
 */
function getAbortFuncKey(url, method) {
    return method ? toLower(`${url}-${method}`) : toLower(url);
}
function requestAbortControllerInterceptor(config) {
    const { method, url = '/' } = config;
    const key = getAbortFuncKey(url, method);
    const abortController = new AbortController();
    abortControllersMap.set(key, abortController);
    config.signal = abortController.signal;
    return config;
}
function responseAbortControllerInterceptor(response) {
    const config = response.config;
    const { method, url = '/' } = config;
    abortControllersMap.delete(getAbortFuncKey(url, method));
    return response;
}
/**
 * Intercepts and handles Axios errors, specifically CanceledError, based on the abortControllerManageConfig.
 *
 * @param {AxiosError} error - The Axios error to be intercepted and handled.
 * @return {Promise<unknown>} A promise that resolves or rejects based on the error and config.
 */
function responseAbortControllerErrorInterceptor(error) {
    const { responseErrorIsEnterCatch } = abortControllerManageConfig;
    if (error instanceof CanceledError && !responseErrorIsEnterCatch) {
        return new Promise(() => { });
    }
    return Promise.reject(error);
}
/**
 * @description: 根据url&method获取对应abort函数
 * @param {string} url '/section'
 * @param {Method} method 'get'
 * @return {*}
 */
function getAbortFuncByUrlAndMethod(url, method) {
    const key = getAbortFuncKey(url, method);
    let abortController = abortControllersMap.get(key);
    if (!abortController) {
        for (const [key, value] of abortControllersMap.entries()) {
            if (key.includes(url)) {
                abortController = value;
            }
        }
    }
    if (abortController instanceof AbortController) {
        const curAbortHook = () => {
            abortController?.abort();
            abortControllersMap.delete(key);
        };
        return curAbortHook;
    }
    return noop;
}
export { getAbortFuncByUrlAndMethod, requestAbortControllerInterceptor, responseAbortControllerErrorInterceptor, responseAbortControllerInterceptor, setAbortControllerManageConfig, };
